<template>
  <el-card :body-style="{ padding: '8px 0' }" class="mt-2">
    <div class="dayplanner-suggestion-item">

      RECOMMENDATIONS

      <div style="display: flex; flex-direction: column; justify-content: flex-end">
        <div>
          <el-button size="mini" @click="onAddItem" style="float: right; margin-right: 8px; width: 60px">add</el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "all"
    },
  },
  computed: {
  },
  methods: {
    onAddItem() {
      this.$emit("add", this.itemId);
    },
  }
};
</script>
